export const courses1 = [
  "Adcanced Algorithm",
  "Big Data Analysis",
  "C++",
  "Advance Cellular Network",
  "Communication Network",
  " Consumer Optoelectronics",
  "Data Structure",
  "Fund Solid State",
  "Internet of things",
  "MEAN Full-Stack Development",
  "Machine Learning",
  "Modern Digital Communication",
  "Object Oriented and Functional Programming",
  "RadioFrequency/Microwa ve Circuits",
  "React Guide",
  "Wearable & Implantable Sensors",
];

export const courses2 = [
  "Adcanced Algorithm",
  "Big Data Analysis",
  "C++",
  "Advance Cellular Network",
  "Communication Network",
  " Consumer Optoelectronics",
  "Data Structure",
  "Fund Solid State",
  "Internet of things",
  "MEAN Full-Stack Development",
  "Machine Learning",
  "Modern Digital Communication",
  "Object Oriented and Functional Programming",
  "RadioFrequency/Microwa ve Circuits",
  "React Guide",
  "Wearable & Implantable Sensors",
];
